<template>

  <div>
    <ul class="rightBar-list rightBar fixed" id="rightBar">
      <li class="app-a">
        <a href="javascript:void(0);" class="app-wx-code">
          <div class="app-wx-code-div"></div>
          <span>微信</span>
        </a>
        <div class="qr-box" id="qrBox">
          <img id="wxmpQrCode" src="/img/erwm01.jpg" alt="">
          <p class="text-bold" style="margin-bottom:10px;">微信公众号</p>
        </div>
      </li>

      <li class="service-a">
        <a href="javascript:void(0);">
          <el-icon style="font-size: 20px; color: #000;">
            <Service />
          </el-icon>
          <span>在线客服</span>
        </a>
        <div class="service-box">
          <a
            class="service-link"
            href="https://wpa1.qq.com/QPNgqRWc?_type=wpa&qidian=true"
            target="_blank"
          >
            <img src="/img/icon_qq.jpg" alt="QQ服务" />
            <span>QQ在线客服</span>
          </a>
          <a
            class="service-link"
            href="https://wpa1.qq.com/VgEx7FPF?_type=wpa&qidian=true"
            target="_blank"
          >
            <img src="/img/icon_wechat.jpg" alt="微信服务" />
            <span>微信在线客服</span>
          </a>
        </div>
      </li>
      <li class="tel-a phone-400">
        <a href="javascript:void(0);">
          <el-icon style="color:#000">
            <Phone />
          </el-icon>
          <span>联系电话</span>
        </a>
        <div class="concact-box">
          <span style="color: #000;"> 010-88614688 </span>
        </div>
      </li>
      <li>
        <a href="javascript:void(0);" role="button" @click.prevent="handleBackToTop">
          <el-icon style="color: #000;">
            <Upload />
          </el-icon>
          <span>回顶部</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { scrollToEaseOut } from "@/utils/scroll-to";

function handleBackToTop() {
  scrollToEaseOut(0, 700);
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  max-width: 1166px;
  width: 100%;
  height: 82px;
  margin: 0 auto;
  padding-top: 23px;

  .text-fuwu {
    position: absolute;
    top: 38px;
    right: 115px;
  }
}

.nav-menu-bg {
  width: 100%;
  margin-top: 21px;
  background: #055ccd;

  .nav-menu {
    width: 100%;
    height: 73px;
    margin-top: 21px;

    .scroll-text {
      font-weight: bold;
      font-size: 16px;
      max-width: 1166px;
      width: 100%;
      margin: 0 auto;
      line-height: 73px;
    }

    ul {
      max-width: 1166px;
      width: 100%;
      margin: 0 auto;
      display: flex;

      li {
        font-size: 24px;
        width: 200px;
        height: 70px;
        text-align: center;
        line-height: 70px;
        font-weight: bold;

        &:hover {
          background-color: #06479c;
          cursor: pointer;
        }
      }
    }
  }
}

// 右侧边栏主样式
.rightBar {
  position: absolute;
  right: 0px;
  border-bottom: 1px solid #e9ecf0;
  width: 60px;
  height: 270px;
  background: #FFFFFF;
  text-align: center;
  z-index: 999999;

  // 固定定位样式（对应 .rightBar.fixed）
  &.fixed {
    position: fixed;
    top: 80px;
  }

  // 侧边栏列表（对应 .rightBar-list）
  &-list {
    li {
      vertical-align: top;
      padding-top: 7px;
      width: 60px;
      height: 60px;
      border: 1px solid #e9ecf0;
      border-bottom: none;
      position: relative;

      // 列表项中的a标签
      a {
        display: block;
        width: 100%;
        height: 100%;

        // a标签hover时，内部iconfont和span变色
        &:hover {

          .iconfont,
          span {
            color: #2a6fdb;
          }
        }
      }

      // 购物车角标（对应 .rightBar-list li.car-a::after）
      &.car-a::after {
        content: attr(data-num);
        position: absolute;
        top: 8px;
        right: 8px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        background: #2a6fdb;
        border-radius: 50%;
        color: #ffffff;
        font-size: 10px;
      }

      // 悬浮显示二维码盒子
      &.app-a:hover .qr-box {
        display: block !important;
      }

      // 悬浮显示联系盒子
      &.tel-a:hover .concact-box {
        display: block !important;
      }

      // 悬浮显示在线客服盒子
      &.service-a:hover .service-box {
        display: block !important;
      }

      // 图标样式
      .iconfont {
        font-size: 20px;
        color: #71797f;
      }

      // 文字描述样式
      span {
        display: block;
        margin-top: 6px;
        font-size: 12px;
        line-height: 17px;
        color: rgba(35, 38, 40, 0.9);
      }

      // 二维码盒子样式
      .qr-box {
        position: absolute;
        left: -148px;
        top: 0;
        width: 138px;
        height: 145px;
        background: #FFFFFF;
        border: 1px solid #E9ECF0;
        padding-top: 12px;
        border-radius: 8px;
        display: none;

        img {
          width: 104px;
          height: 104px;
        }

        p {
          margin-top: 2px;
          font-size: 13px;
          line-height: 18px;
        }

        .text-bold {
          color: #232628;
          font-weight: 600;
        }

        .text-grey {
          color: #71797F;
        }
      }

      // 联系盒子样式
      .concact-box {
        position: absolute;
        top: 9px;
        left: -148px;
        border-radius: 8px;
        width: 138px;
        height: 42px;
        line-height: 42px;
        background: #FFFFFF;
        border: 1px solid #E9ECF0;
        display: none;

        span {
          display: inline-block;
          font-size: 13px;
          line-height: 18px;
          color: #71797f;
          vertical-align: middle;
          margin-top: 0;
        }
      }

      .service-box {
        position: absolute;
        top: 0;
        left: -176px;
        width: 176px;
        background: #ffffff;
        border: 1px solid #e9ecf0;
        border-radius: 8px;
        display: none;
        padding: 10px 8px;
        box-sizing: border-box;

        // 鼠标从按钮移动到弹框时的过渡区域，避免中途失焦导致弹框闪退
        &::after {
          content: "";
          position: absolute;
          right: -12px;
          top: 0;
          width: 12px;
          height: 100%;
        }

        .service-link {
          width: 100%;
          height: 40px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          padding: 0 8px;
          box-sizing: border-box;
          text-decoration: none;

          &:hover {
            background: #f4f8ff;
          }

          img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin-right: 8px;
          }

          span {
            margin-top: 0;
            font-size: 13px;
            color: #232628;
            line-height: 18px;
          }
        }
      }
    }
  }
}

.app-wx-code-div {
  width: 20px;
  margin: auto;
  height: 20px;
  background: url(~@/assets/images/qrCode.png) no-repeat;
  background-size: 100%;
}

/* 平板：宽度 ≤ 768px */
@media (max-width: 1200px) {
  .rightBar {
    position: absolute;
    right: -1000px;
  }
}
</style>
